/* @flow */
import Collection from 'lib/Collection';
import ActivityRecipient from 'entities/ActivityRecipient';

export default class ActivityRecipients extends Collection {
  initialize() {
    this.model = ActivityRecipient;
  }

  parse(response: Object) {
    return response.map(recipient => ActivityRecipient.fromJSON(recipient));
  }
}



// WEBPACK FOOTER //
// ./src/collections/ActivityRecipients.js